import gray from "gray-percentage"

export const DiabeticRed = "rgb(183, 28, 28)"
export const Gray = gray(41)
export const GRAY_BACKGROUND = "rgba(243,247,249,1)"
